import {addNotification, initialNotifications} from './actionCreators';

const getUserNotificationStore = (CSRFMiddlewareToken, dispatch, onReady) => {
    let initialized = false;

    return (initial, addNotifications) => {
        if (initialized) throw new Error('UserNotificationStore could only be initialized once.');

        dispatch(initialNotifications({...initial, CSRFMiddlewareToken}));
        addNotifications((...args) => dispatch(addNotification(...args)));
        onReady();

        initialized = true;
    };
};

export default getUserNotificationStore;
